import { type UNSAFE_any, type CoreBundleItemPayload } from '@flecto/types'

import { api } from '../../../services/api'

export type AIProductPhotoParams =
  | { title: string; items?: never }
  | { title?: never; items: Array<CoreBundleItemPayload> }

export type GetAIProductPhotosListOptions = {
  limit?: number
  offset?: number
  signal?: AbortSignal
}

type GetAIItemPhotosListResponse = {
  images: string[]
  count?: number
  limit?: number
  offset?: number
  total?: number
}

export function serializeQueryParams(params: Record<string, UNSAFE_any>): string {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${key}[]=${encodeURIComponent(v)}`).join('&')
      }
      return `${key}=${encodeURIComponent(value)}`
    })
    .join('&')
}

/**
 * Get product photos list generated by AI.
 *
 * @endpoint GET /ai/product/photos/generate
 * @scope shared
 * @see MISSING_URL
 */

export async function getAIProductPhotosList(
  params: AIProductPhotoParams,
  options?: GetAIProductPhotosListOptions
): Promise<GetAIItemPhotosListResponse> {
  const requestParams = {
    ...(params.title !== undefined && { title: params.title }),
    ...(params.items !== undefined && {
      item_ids: params.items.map((item) => item.item_id),
    }),
    limit: options?.limit,
    offset: 0,
  }

  const response = await api.get('/api/ai/product/photos/generate', {
    params: requestParams,
    signal: options?.signal,
    paramsSerializer: serializeQueryParams,
  })

  return response?.data ?? { images: [], meta: {} }
}
